import { useContext } from 'react';

import CropFailedOrdersContext from './CropFailedOrdersContext';

const useCropFailedOrders = () => {
  return useContext(CropFailedOrdersContext);
};

export default useCropFailedOrders;
